import {stringify} from 'qs'
import request from 'app-self-support-order/utils/request'
import api from 'app-self-support-order/common/api/customer'

export async function search(payload) {
    return request(`${api.search.url}?${stringify(payload.params)}`, {
        method: api.search.type,
        body: payload.body,
    })
}

export async function getExternalUserIds(payload) {
    return request(api.getExternalUserIds.url, {
        method: api.getExternalUserIds.type,
        body: payload.body,
    })
}
